<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content">
        <el-form
          ref="settlementForm"
          :model="settlement"
          class="box"
          label-width="100px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.title')">{{
                  settlement.title
                }}</el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item :label="$t('settlement.amount')">
                  {{ settlement.settleAmount | currency }}
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item :label="$t('settlement.settlerName')">{{
                  settlement.settlerName
                }}</el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('text.createAt')">{{
                  settlement.createdAt
                }}</el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('settlement.settle')">
                  {{ $t("boolean." + settlement.settle) }}
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item :label="$t('settlement.searchCondition')">{{
                  settlement.searchCondition
                }}</el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import SaleSettlement from "@/api/saleSettlement.js";

export default {
  props: {
    id: Number,
  },
  mixins: [page],
  components: {},
  data() {
    return {
      settlement: { settle: false },
      items: [],
    };
  },
  mounted() {
    // 根据id请求bargain
  },
  created() {
    const self = this;
    self.loadingStart();
    SaleSettlement.findById(self.id).then(function (res) {
      if (res.data.code === 200) {
        self.settlement = res.data.entity;
      } else {
        self.sysError();
      }
      self.loadingEnd();
    });
  },
  methods: {},
};
</script>